import axios from '../api/axiosPublic';

// Login admin user
export const loginUser = (username, password) => {
  return axios.post('/login', { username, password });
};
